/**
 * Org-level admin restructure — GA for all orgs: the `orgLevelAdmin` org flag is
 * no longer read.
 *
 * Kept (name + signature) so the call sites that branch on it keep compiling.
 * It covers: Continue routing straight to Program Designer (MC/GM) or Matches
 * (MS), the program Members & Settings tabs moving up to Org Members, and
 * resources managed from the left-nav Resources item.
 */
const useOrgLevelAdmin = (): boolean => true;

export default useOrgLevelAdmin;
